import { Button, Icon_ShaprLogo, Link } from "@shapr3d/frontend-lib";

import { eduLicenseEligibilityURL } from "../../config";
import useNavigation from "../../hooks/navigation";
import Heading from "../Heading/Heading";

import style from "./InvalidEduRequest.module.css";

export enum InvalidEduRequestType {
  IneligibleEmail,
  Unavailable,
  EmailVerificationRequired,
}

export interface InvalidEduRequestProps {
  type: InvalidEduRequestType;
}

export const InvalidEduRequest = (props: InvalidEduRequestProps) => {
  const { goToProfile } = useNavigation();

  const content = {
    [InvalidEduRequestType.IneligibleEmail]: {
      title: "Ineligible email address",
      text: (
        <>
          <p>
            Your email address isn&apos;t eligible for the Shapr3D EDU license.
            <br /> Make sure you&apos;re using the email address provided by your institution.{" "}
          </p>
          To check your eligibility, visit{" "}
          <Link href={eduLicenseEligibilityURL} target="_blank">
            EDU license eligibility.
          </Link>
        </>
      ),
      goToProfileText: "Change my email",
    },
    [InvalidEduRequestType.Unavailable]: {
      title: "EDU license is unavailable",
      text: (
        <>
          We are restructuring our educational program. <br /> The relaunch has no definite time at
          the moment. <br /> Check our pricing page to see other options.
        </>
      ),
      goToProfileText: "See Subscriptions",
    },
    [InvalidEduRequestType.EmailVerificationRequired]: {
      title: "Email verification required",
      text: (
        <>
          <p>
            You must verify your email address to apply for an EDU license.
            <br /> Please check your email or click below to verify.
          </p>
          To check your eligibility, visit{" "}
          <Link href={eduLicenseEligibilityURL} target="_blank">
            EDU license eligibility.
          </Link>
        </>
      ),
      goToProfileText: "Verify your email",
    },
  };

  return (
    <section>
      <div className={style.container}>
        <Icon_ShaprLogo height={156} />
        <Heading type="h1">{content[props.type].title}</Heading>

        <div className={style.text}>{content[props.type].text}</div>

        <Button className={style.button} onClick={() => goToProfile()}>
          {content[props.type].goToProfileText}
        </Button>
      </div>
    </section>
  );
};
